import { useState } from "react";
import { TripTable } from "@/app/Cities/Trips/Components/TripTable";
import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { useCityRecord } from "@/app/Cities/Cities/Hooks/useCityRecord";
import { CityFilter } from "@/lib/Components/DataTable/Filters/CityFilter";

export function CityTripScreen() {
  const city = useCityRecord();
  const [otherCityId, setOtherCityId] = useState<string>();

  return (
    <RecordScreenCard>
      <TripTable
        id={"city-trips"}
        queryVariables={{
          cityIds: otherCityId ? [city.id, otherCityId] : [city.id],
        }}
        filters={
          <CityFilter
            placeholder="Other city"
            selected={otherCityId ? [otherCityId] : []}
            regions={[city.region]}
            onChange={(ids) => setOtherCityId(ids.at(-1))}
          />
        }
      />
    </RecordScreenCard>
  );
}
